export const TOGGLE_COLLAPSE = 'TOGGLE_COLLAPSE';
export const SET_LATERAL_MENU_COLLAPSE = 'SET_LATERAL_MENU_COLLAPSE';